"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _NotifyIcon = _interopRequireDefault(require("../NotifyIcon"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CalendarNav = _styledComponents["default"].nav(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas: 'prev title next';\n  grid-template-columns: min-content 1fr min-content;\n  grid-template-rows: 1fr;\n  padding: 0 var(--padding);\n  background: var(--primary);\n  color: #353535;\n  height: 70px;\n"])));
var HeaderTitle = _styledComponents["default"].h1(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  grid-area: title;\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  font-size: 30px;\n  font-weight: 400;\n  line-height: 66px;\n  cursor: pointer;\n\n  small {\n    font-weight: 300;\n    font-size: 0.6em;\n    transform: translateY(7%);\n  }\n"])));
var NavBtn = _styledComponents["default"].button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  all: unset;\n  width: 30px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 1;\n  padding-bottom: 0.15em;\n  cursor: pointer;\n\n  &.prev {\n    margin-left: -5px;\n  }\n\n  &.next {\n    margin-right: -5px;\n  }\n"])));
function Header(_ref) {
  var dates = _ref.dates,
    setDates = _ref.setDates;
  var date = dates.date;
  var changeMonth = function changeMonth(event, newMonth) {
    event.preventDefault();
    event.stopPropagation();
    setDates(_objectSpread(_objectSpread({}, dates), {}, {
      date: (0, _moment["default"])(date).month(newMonth)
    }));
  };
  var onPrev = function onPrev(e) {
    return changeMonth(e, date.month() - 1);
  };
  var onNext = function onNext(e) {
    return changeMonth(e, date.month() + 1);
  };
  var onReset = function onReset() {
    return setDates(_objectSpread(_objectSpread({}, dates), {}, {
      date: (0, _moment["default"])()
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(CalendarNav, null, /*#__PURE__*/_react["default"].createElement(NavBtn, {
    className: "prev",
    onClick: onPrev
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    iconName: "chevronLeft"
  })), /*#__PURE__*/_react["default"].createElement(HeaderTitle, {
    onClick: onReset
  }, date.format('MMMM'), " ", /*#__PURE__*/_react["default"].createElement("small", null, date.format('YYYY'))), /*#__PURE__*/_react["default"].createElement(NavBtn, {
    className: "next",
    onClick: onNext
  }, /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
    iconName: "chevronRight"
  })));
}
Header.propTypes = {
  dates: _propTypes["default"].shape().isRequired,
  setDates: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Header);